<template>
  <div id="app">
    <transition name="loading-fade">
      <div v-if="!appReady" class="site-loading" role="status" aria-live="polite" aria-label="正在加载富贵泉网站">
        <div class="site-loading__card">
          <img src="@/assets/img/logo.png" alt="富贵泉">
          <div class="site-loading__line"><span></span></div>
          <p>正在加载富贵泉网站</p>
        </div>
      </div>
    </transition>
    <myheader v-if="$store.state.winWidth > 768" v-show="path && path!='feadback' && !path.includes('job')"></myheader>
    <mobheader v-else  v-show="path && !path.includes('job')"></mobheader>
    <main>
      <router-view :class="{marTop:path=='contactUs' || path== 'news' || path=='afterSale' || path=='guide'}"></router-view>
    </main>
    <myfooter v-if="$store.state.winWidth > 768" v-show="path && path!='feadback' && !path.includes('job')"></myfooter>
    <mobfooter v-else  v-show="path && !path.includes('job')"></mobfooter>
  </div>
</template>

<script>
import myheader from "@/components/Header.vue"
import myfooter from "@/components/Footer.vue"
import mobheader from "@/components/mobHeader.vue"
import mobfooter from "@/components/mobFooter.vue"
import { trackPageView } from '@/utils/customerTracking'
export default {
  name: 'App',
  components: {
    myheader,
    myfooter,
    mobheader,
    mobfooter
  },
  data() {
    return {
      appReady: false
    }
  },
  computed:{
path(){
  console.log(this.$route.name);
  
  return this.$route.name
}
  },
  watch: {
    '$route.fullPath': {
      immediate: true,
      handler() {
        this.$nextTick(() => trackPageView(this.$api, 'zh'))
      }
    }
  },
  mounted() {
    Promise.allSettled([this.getNavs(), this.getOption()]).finally(() => {
      this.appReady = true
    })
    this.$store.commit('setWidth', window.innerWidth)
    this.$store.commit('setScroll', window.scrollY)
    window.addEventListener('resize', this.handleResize)
    window.addEventListener('scroll', this.handleScroll)


  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize)
    window.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    handleResize() {
      this.$store.commit('setWidth', window.innerWidth)
      if (window.innerWidth > 768) {
        document.body.style.overflow = ''
      }
    },
    handleScroll() {
      this.$store.commit('setScroll', window.scrollY)
    },
    getNavs() {
      return this.$api.getNavs().then(res => {
        if (res && res.code == 1) {
          this.$store.commit('setMenu', {
            ddsh: res.data.ddsh,
            ddsl: res.data.ddsl,
            fgkj: res.data.fgkj,
            fwzc: res.data.fwzc,
            gywm: res.data.gywm,
            list: res.data.list
          })

        }
      }).catch(() => {})
    },
    getOption() {
      return this.$api.getOption({
        type: "kf_phone,kf_logo,kf_worktime,site_copyright,site_icp,main_logo,second_logo,site_name,site_analytics,zp_logo,zp_company,zp_intro,zp_title,zp_content,site_analytics,city"
      }).then(res => {
        if (res && res.code == 1) {
          this.$store.commit('setdataInfo', res.data)
        }
      }).catch(() => {})
    },
  },
}
</script>

<style scoped>
.site-loading {
  position: fixed;
  inset: 0;
  z-index: 3000;
  display: grid;
  place-items: center;
  background:
    radial-gradient(circle at 50% 38%, rgba(176, 13, 22, 0.08), transparent 32%),
    #f7f7f5;
}

.site-loading__card {
  width: min(360px, 72vw);
  text-align: center;
}

.site-loading__card img {
  width: min(190px, 48vw);
  height: auto;
  object-fit: contain;
}

.site-loading__card p {
  margin: 20px 0 0;
  color: #5c5c5c;
  font-size: 14px;
  letter-spacing: 0.12em;
}

.site-loading__line {
  width: 100%;
  height: 3px;
  margin-top: 30px;
  overflow: hidden;
  border-radius: 999px;
  background: #e4e4e1;
}

.site-loading__line span {
  display: block;
  width: 42%;
  height: 100%;
  border-radius: inherit;
  background: #b00d16;
  animation: site-loading 1.15s ease-in-out infinite;
}

.loading-fade-leave-active { transition: opacity 0.3s ease; }
.loading-fade-leave-to { opacity: 0; }

@keyframes site-loading {
  from { transform: translateX(-110%); }
  to { transform: translateX(250%); }
}

@media (prefers-reduced-motion: reduce) {
  .site-loading__line span { animation-duration: 2.4s; }
}
</style>
